(() => {
  const desktop = window.matchMedia('(min-width: 900px)');

  const syncGroups = (root) => {
    root.querySelectorAll('[data-auv-footer-group]').forEach((group) => {
      group.open = desktop.matches;
    });
  };

  const initFooter = (root) => {
    if (!root || root.dataset.footerReady === 'true') return;
    root.dataset.footerReady = 'true';
    syncGroups(root);

    const onBreakpointChange = () => syncGroups(root);
    if (desktop.addEventListener) desktop.addEventListener('change', onBreakpointChange);
    else desktop.addListener(onBreakpointChange);
  };

  const initAll = (scope = document) => {
    scope.querySelectorAll('[data-auv-footer]').forEach(initFooter);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll());
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
})();
